if (!customElements.get('timeline-popup')) {
  class TimelinePopup extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(event) {
      if (this.getAttribute('data-id') != event.detail.id) return;

      this.classList.toggle('is-open');
      toggleLock(this.classList.contains('is-open'), this);
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:toggle-timeline-popup',
        this.handleToggleRef,
      );
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      document.addEventListener(
        'exo:toggle-timeline-popup',
        this.handleToggleRef,
      );
    }
  }

  customElements.define('timeline-popup', TimelinePopup);
}
